import { styled } from "@mui/material";
import { selectClasses, Select } from "@mui/base/Select";

export const StyledBaseSelectRoot = styled(Select, {
  shouldForwardProp: (prop) => prop !== "$error",
})<{ $error?: boolean }>(({ theme, $error }) => ({
  [`&.${selectClasses.root}`]: {
    width: "100%",
    position: "relative",
    color: theme.wsc.palette.neutral[100],
    fontSize: theme.wsc.typography.body1.fontSize,
    border: `1px solid ${theme.wsc.palette.neutral[500]}`,
    borderRadius: theme.wsc.radius.m,
    padding: `${theme.wsc.spacing[0]} ${theme.wsc.spacing[1]}`,
    backgroundColor: theme.wsc.palette.neutral[700],
    textAlign: "left",
    cursor: "pointer",

    "&:hover": {
      backgroundColor: theme.wsc.palette.neutral[600],
      borderColor: theme.wsc.palette.neutral[600],
    },

    "&:focus": {
      borderColor: theme.wsc.palette.neutral[0],
      backgroundColor: theme.wsc.palette.neutral[500],
      borderRadius: theme.wsc.radius.m,
    },

    ...($error && {
      borderColor: theme.wsc.palette.warning[300],
    }),
  },

  [`&.${selectClasses.focusVisible}`]: {
    backgroundColor: theme.wsc.palette.neutral[500],
    borderColor: theme.wsc.palette.neutral[0],
  },

  [`&.${selectClasses.disabled}`]: {
    backgroundColor: theme.wsc.palette.neutral[600],
    borderColor: theme.wsc.palette.neutral[500],
    color: theme.wsc.palette.neutral[300],
    cursor: "auto",

    "&:hover, &:focus": {
      backgroundColor: theme.wsc.palette.neutral[600],
      borderColor: theme.wsc.palette.neutral[500],
    },
  },
}));

export const StyledPlaceholder = styled("div")`
  color: ${({ theme }) => theme.wsc.palette.neutral[300]};
  ${({ theme }) => theme.wsc.typography.body1};
  line-height: 1.571rem;
  padding: 0 ${({ theme }) => theme.wsc.spacing[0]};
`;

export const StyledDateTitle = styled("div")`
  ${({ theme }) => theme.wsc.typography.body2};
  color: ${({ theme }) => theme.wsc.palette.neutral[100]};
  padding: ${({ theme }) => theme.wsc.spacing[1]}
    ${({ theme }) => theme.wsc.spacing[2]};
`;

export const StyledSearchableEntityDropdown = styled("div")``;
